var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEquipeMedica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0899ba;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-356 -606)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 455)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-702 -133)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(1059 284)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.896 619.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M399.875,273.32h-1.381a3.593,3.593,0,0,1,.218,1.235v5.218a1.538,1.538,0,0,1-.089.515h2.283a1.548,1.548,0,0,0,1.546-1.546V275.9A2.58,2.58,0,0,0,399.875,273.32Z",
    transform: "translate(-398.494 -273.32)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(361 619.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.74,274.556a3.591,3.591,0,0,1,.218-1.235H2.577A2.58,2.58,0,0,0,0,275.9v2.845a1.548,1.548,0,0,0,1.546,1.546H3.829a1.539,1.539,0,0,1-.089-.516Z",
    transform: "translate(0 -273.321)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(365.771 618.007)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.563,234.815h-3.157a2.58,2.58,0,0,0-2.577,2.577v5.218a.515.515,0,0,0,.515.515h7.28a.515.515,0,0,0,.515-.515v-5.218A2.58,2.58,0,0,0,142.563,234.815Z",
    transform: "translate(-136.829 -234.815)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(366.827 611.173)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.213,38.84a3.1,3.1,0,1,0,3.1,3.1A3.1,3.1,0,0,0,170.213,38.84Z",
    transform: "translate(-167.114 -38.84)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.166 614.062)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.761,121.689a2.317,2.317,0,1,0,2.318,2.318A2.321,2.321,0,0,0,35.761,121.689Z",
    transform: "translate(-33.443 -121.689)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(373.052 614.062)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.925,121.689a2.318,2.318,0,1,0,2.318,2.318A2.321,2.321,0,0,0,347.925,121.689Z",
    transform: "translate(-345.607 -121.689)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEquipeMedica);
export default __webpack_public_path__ + "static/media/icon-equipe-medica.8b60f73c1177aed0614087b7f1d835a2.svg";
export { ForwardRef as ReactComponent };